var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('SupplierRecruit'),_c('TraditionalEnterprise'),_c('Slogan'),_c('IntegrationManage'),_c('OurAbility'),_c('CoreAbility'),_c('CoreBright'),_c('MultiTerminalAdapt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }